"use client";
import { jsx } from "react/jsx-runtime";
const AppleIcon = (props) => {
  return /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", ...props, children: /* @__PURE__ */ jsx(
    "path",
    {
      d: "M20.6856 16.6738C20.2168 17.7149 19.9909 18.1802 19.388 19.099C18.5439 20.383 17.3534 21.9863 15.8826 21.9964C14.5732 22.0083 14.2352 21.1422 12.457 21.1575C10.6805 21.1659 10.3103 22.0134 8.99916 21.9998C7.52669 21.9863 6.40068 20.5427 5.55659 19.2604C3.19588 15.665 2.94622 11.4497 4.40511 9.20782C5.43771 7.61816 7.06983 6.68407 8.60345 6.68407C10.1659 6.68407 11.1476 7.54174 12.4383 7.54174C13.6917 7.54174 14.4543 6.68237 16.2613 6.68237C17.6268 6.68237 19.0704 7.42625 20.103 8.71021C16.7267 10.5614 17.2753 15.383 20.6856 16.6738ZM14.8891 5.24726C15.5463 4.40317 16.0456 3.21263 15.8639 2C14.7923 2.07303 13.5389 2.75747 12.8069 3.64401C12.1428 4.45243 11.5926 5.65147 11.8065 6.81144C12.9767 6.84881 14.1876 6.15078 14.8891 5.24726Z",
      fill: "white"
    }
  ) });
};
export {
  AppleIcon
};
